export const environment = {
  base_url: 'https://dev.api.hakim.dssystemas.com.br',
};
